import React from 'react';
import FormField from './FormField';

const RadioGroup = ({ 
  label, 
  options, 
  name, 
  register, 
  error, 
  onChange,
  defaultValue 
}) => {
  return (
    <FormField label={label} error={error}>
      <div className="d-flex gap-3">
        {options.map((option) => (
          <div key={option.value} className="border rounded p-3">
            <input
              className="form-check-input"
              type="radio"
              value={option.value}
              id={`${name}_${option.value}`}
              defaultChecked={option.value === defaultValue}
              {...register(name, { required: true })}
              onChange={() => onChange && onChange(option.value)}
            />
            <label className="text-black ps-2" htmlFor={`${name}_${option.value}`}>
              {option.label}
            </label>
          </div>
        ))}
      </div>
    </FormField>
  );
};

export default RadioGroup;